/**
 * RestoID — MFA authenticator-app (TOTP) verification.
 * ---------------------------------------------------------------------------
 * RestoID frame around `custom/components/TotpCodeEntry` — NOT upstream's
 * `TotpCodeVerification`: the code entry and submit are equivalent, but a wrong
 * code surfaces as a RestoID toast instead of upstream's inline error row.
 * `MfaSwitchLink` comes from `custom/components/MfaFactorRows`. Replaces Logto's
 * double-title SecondaryPageLayout + SectionLayout with a single ScreenHead.
 * Swapped in for `./pages/MfaVerification/TotpVerification` via `src/App.tsx`.
 */
import { useTranslation } from 'react-i18next';

import FirstScreenLayout from '@/Layout/FirstScreenLayout';
import useMfaFlowState from '@/hooks/use-mfa-factors-state';
import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';
import { UserMfaFlow } from '@/types';

import { MfaSwitchLink } from '../components/MfaFactorRows';
import TotpCodeEntry from '../components/TotpCodeEntry';
import { ScreenHead, Stack } from '../components/restoid';
import { useCopy } from '../copy';

import ErrorPage from './ErrorPage';

const MfaTotpVerification = () => {
  const { t } = useTranslation();
  const c = useCopy();
  const navigate = useNavigateWithPreservedSearchParams();
  const flowState = useMfaFlowState();

  if (!flowState) {
    return <ErrorPage title="error.invalid_session" />;
  }

  return (
    <FirstScreenLayout pageMeta={{ titleKey: 'mfa.enter_one_time_code' }}>
      <Stack gap={20}>
        <ScreenHead
          back={() => navigate(-1)}
          backLabel={c('backShort')}
          title={t('mfa.enter_one_time_code')}
          sub={c('mfaVerifyTotpDesc')}
        />
        <TotpCodeEntry flow={UserMfaFlow.MfaVerification} />
        <MfaSwitchLink flow={UserMfaFlow.MfaVerification} flowState={flowState} />
      </Stack>
    </FirstScreenLayout>
  );
};

export default MfaTotpVerification;
